import "./DeleteModal.styles.scss";
import React from "react";
import { useTranslation } from "react-i18next";
import { Modal, Icon, Button } from "components";
import WarningIcon from "assets/icons/exclamation-triangle.svg";

interface DeleteModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void | Promise<void>;
  title?: string;
  label?: string;
  hint?: string;
  confirmBtnValue?: string;
  cancelBtnValut?: string;
  loading?: boolean;
  fullScreen?: boolean;
  onCloseModal?: () => void;
}

const DeleteModal = ({
  isOpen,
  onCancel,
  onConfirm,
  title,
  label,
  hint,
  confirmBtnValue,
  cancelBtnValut,
  loading,
  fullScreen,
  onCloseModal,
}: DeleteModalProps) => {
  const { t } = useTranslation(["common"]);

  return (
    <Modal
      isOpen={isOpen}
      overlayExtraClass={fullScreen ? "delete-modal-overlay" : ""}
      innerExtraClass={fullScreen ? "delete-modal-inner" : ""}
      onClose={() => onCloseModal && onCloseModal()}
    >
      <div className="delete-component">
        <div className="delete-component_icon">
          <Icon src={WarningIcon} />
        </div>
        <div className="delete-component_title">
          {title ? title : t("confirmations.confirm_delete", { label: label })}
        </div>
        <div className="delete-component_body">
          {hint ? hint : t("confirmations.confirm_delete_body2")}
        </div>
        <div className="delete-component_buttons">
          <Button
            onClick={onCancel}
            name="cancel_delete_file_button"
            value={cancelBtnValut ? cancelBtnValut : t("buttons.never_mind")}
            extraClass="secondary-bland"
            size="small"
          />
          <Button
            onClick={onConfirm}
            name="confirm_delete_file_button"
            value={
              confirmBtnValue ? confirmBtnValue : t("buttons.confirm_delete")
            }
            isLoading={loading}
            extraClass="danger"
            size="small"
          />
        </div>
      </div>
    </Modal>
  );
};

export default DeleteModal;
